import { type UseQueryResult, useQuery } from 'react-query';
import {
  FairValueService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { skipDecimalConversion } from '../../utils/apiDecimalConfig';

const useGetFairValueById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  payload: { awardId: string; awardType?: string }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto | undefined,
  unknown
> => {
  const fairValueById = useQuery(['getFairValueById'], async () => {
    return await handleRequest(
      skipDecimalConversion(
        FairValueService.getApiAwardApiAppFairValueFairValueByAwardId(
          payload?.awardId,
          payload.awardType
        )
      )
    );
  });

  return fairValueById;
};

export default useGetFairValueById;
